import {AfterViewInit, Component, Inject, Input, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';
import { EventsDetailByVenue } from '@biletix/core/models/event/events-detail-by-venue.model';
import {PerformancePageStateService} from "@biletix/features/performance/services/performance-page-state.service";

@Component({
    standalone: false,
    selector: 'btx-venue-seat-plan-image-modal',
    templateUrl: './venue-seat-plan-image-modal.component.html',
    styleUrls: ['./venue-seat-plan-image-modal.component.scss']
})
export class VenueSeatPlanImageModalComponent implements OnInit,AfterViewInit {

  seatPlanImage: string | undefined;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.seatPlanImage = this.getEventSeatPlanImage();
        
    }

    ngOnInit(): void {      
      this.seatPlanImage = this.getEventSeatPlanImage();
    }


    ngAfterViewInit(): void {
    }

    getEventSeatPlanImage(): string {
        return ImageUrlManager.createSeatPLanImage(
          this.data.seatPlanImage
        );
      }

}
